// extracted by mini-css-extract-plugin
var _1 = "sgglI3uiyU";
export { _1 as "root" }
